export default "__VITE_ASSET__BfxM1YnE__"